/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipient_StorageInputs */

const da_privacy_recipient_storage = /** @type {(inputs: Privacy_Recipient_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagring af filer, dvs. de anonymiserede besvarelser og materialerne.`)
};

/** @type {(inputs: Privacy_Recipient_StorageInputs) => LocalizedString} */
const en_privacy_recipient_storage = da_privacy_recipient_storage;

/**

* @param {Privacy_Recipient_StorageInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipient_storage = /** @type {((inputs?: Privacy_Recipient_StorageInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipient_StorageInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipient_storage(inputs)
	return /** @type {LocalizedString} */ ("Lagring af filer, dvs. de anonymiserede besvarelser og materialerne.")
});